import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SignInForm from "../../components/SignInForm";
import SEOHead from "../../components/SEO/SEOHead";
import { checkAndShowTimeoutMessage } from "../../utility/security/sessionUtils";

const SignIn = () => {
  const location = useLocation();
  
  useEffect(() => {
    checkAndShowTimeoutMessage();
    
    // Save the referring page if not already set and if it's not /signin itself
    if (!sessionStorage.getItem("signInDestination")) {
      const referrer = document.referrer;
      if (referrer && referrer !== window.location.href) {
        try {
          const referrerUrl = new URL(referrer);
          const referrerPath = referrerUrl.pathname + referrerUrl.search;
          // Only save if it's from our domain and not the signin page
          if (
            referrerUrl.hostname === window.location.hostname &&
            referrerPath !== "/signin" &&
            referrerPath !== "/signup"
          ) {
            sessionStorage.setItem("signInDestination", referrerPath);
          }
        } catch (e) {
          // Invalid URL, ignore
        }
      }
    }
  }, []);

  return (
    <div>
      <SEOHead
        title="Sign in - Bowling Tournament App"
        description="Sign in to Bowling Tournament App."
        canonicalUrl="/signin"
        noIndex
      />
      <SignInForm />
    </div>
  );
};

export default SignIn;
